// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1tP7I","col":"CardReaderDesc_col__-izA5","label":"CardReaderDesc_label__2j1Oi"};